import React from 'react';

import { addressFieldNames as fields } from '../address/addressModule';
import {
    defaultFieldProps,
    addressPropTypes
} from './addressFieldsModule';

import { fieldValidatorsAU } from './addressValidation';
import addressFields from './addressFieldMessages';
import australiaStateMap from './data/AUStateMap';
import {
    Street1Field,
    Street2Field,
    CityField,
    StateSelectField,
    PostalCodeField
} from './Fields';
import postalCodeNormalizerAU from '../validate/postalCodeNormalizarAU';


export const makeStateList = (intl) => {
    const states = Object.keys(australiaStateMap);
    const placeholder = {
        value: '',
        label: intl.formatMessage(addressFields.AU.stateLabel)
    };
    return [placeholder].concat(states.map(code => ({
        value: code,
        label: intl.formatMessage(australiaStateMap[code])
    })));
};


export const AddressFieldsAU = ({
    addressContext,
    cashbotName,
    doFieldValidation,
    intl,
    showUntouchedErrors,
    updateShippingAddress,
    useAddressAutocomplete,
    validators,
    countryCode
}) => {
    const commonFieldProps = {
        addressContext,
        cashbotName,
        doFieldValidation,
        intl,
        showUntouchedErrors
    };
    const street1Props = {
        ...commonFieldProps,
        label: addressFields.DEFAULT.street1Label,
        updateShippingAddress,
        useAddressAutocomplete,
        validate: validators.get(fields.ADDRESS_STREET1),
        countryCode
    };
    const street2Props = {
        ...commonFieldProps,
        validate: validators.get(fields.ADDRESS_STREET2),
        label: addressFields.AU.street2Label
    };
    const cityProps = {
        ...commonFieldProps,
        label: addressFields.DEFAULT.cityLabel,
        validate: validators.get(fields.ADDRESS_CITY)
    };
    const stateProps = {
        ...commonFieldProps,
        label: addressFields.AU.stateLabel,
        options: makeStateList(intl),
        validate: validators.get(fields.ADDRESS_STATE)
    };
    const postalCodeProps = {
        ...commonFieldProps,
        fieldType: 'tel',
        normalize: postalCodeNormalizerAU,
        label: addressFields.AU.postalCodeLabel,
        validate: validators.get(fields.ADDRESS_POSTCODE)
    };

    return (
        <React.Fragment>
            <Street1Field {...street1Props} />
            <Street2Field {...street2Props} />
            <CityField {...cityProps} />
            <StateSelectField {...stateProps} />
            <PostalCodeField {...postalCodeProps} />
        </React.Fragment>
    );
};

AddressFieldsAU.defaultProps = {
    ...defaultFieldProps,
    validators: fieldValidatorsAU
};

AddressFieldsAU.propTypes = {
    ...addressPropTypes
};

export default AddressFieldsAU;
